import { Component } from "@angular/core";
import { UserAccountEmailChangeComponent } from "./forms/user-account-email-change.component";
import { UserAccountPasswordChangeComponent } from "./forms/user-account-password-change.component";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { UnauthorizedComponent } from "@ponder-shared/components/unauthorized.component";
import { UserSettingsCategory } from "../user-settings-category";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "user-account-security-settings",
    imports: [
        LoadingComponent,
        UnauthorizedComponent,
        UserAccountEmailChangeComponent,
        UserAccountPasswordChangeComponent
    ],
    templateUrl: "./user-account-security-settings.component.html"
})
export class UserAccountSecuritySettingsComponent {
    public isLoading: boolean = true;
    public authSession?: AuthSession;

    public constructor(private events: EventBroker, private authService: AuthService) {
        
    }

    public ngOnInit(): void {
        this.events.account.categorySelected.emit(UserSettingsCategory.Security);

        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            this.authSession = authSession;
            this.isLoading = false;
        });
    }
}